import { ParametroModel } from '../utilidades.modelos.index';

export class AccionModel {
	constructor() { }

	public Metodo: string = "";
	public Accion: string = "";
	public Controlador: string = "";
	public Documentacion: string = "";
	public Parametros: ParametroModel[] = [];
	public Ruta: string = "";
	public TipoDevuelto: string = "";
}